<template>
  <div class="result-wheel"></div>
</template>

<script>
import { mapGetters } from 'vuex'
import sdgWheels from './../../../js/sdg-wheel/sdg-wheels'

export default {
  name: 'result-wheel',
  props: {
    phaseIndex: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      // activePageCode: 'getActivePageCode',
      project: 'getProject',
      activePhaseIndex: 'getActivePhaseIndex',
      iconsPath: 'getIconsPath',
      taskDataChanged: 'getTaskDataChanged'
    })
  },
  methods: {
    createSvg () {
      this.$el.innerHTML = ''
      let phaseIndex = this.phaseIndex
      if (this.phaseIndex === undefined) {
        phaseIndex = this.activePhaseIndex
      }
      let activePhaseIndex = this.project.contentJson.phases[phaseIndex]
      let data = {
        phase: {
          code: activePhaseIndex.code,
          name: activePhaseIndex.name
        },
        goals: activePhaseIndex.goals.filter(goal => goal.selected && goal.tasks.filter(task => task.selected || task.custom).length > 0).map(goal => {
          return {
            code: goal.code,
            targets: goal.tasks.filter(task => task.selected || task.custom).map(task => {
              return {
                code: task.code,
                score: task.completedPct,
                disabled: !(task.how && task.what),
                negative: task.negative
              }
            })
          }
        })
      }

      this.jsWheel = new sdgWheels.ResultPct(data, { icons: this.iconsPath })

      this.$el.appendChild(this.jsWheel.getSvg())
    }
  },
  watch: {
    activePhaseIndex (val, oldVal) {
      if (val !== oldVal) {
        this.createSvg()
      }
    },
    taskDataChanged (val, oldVal) {
      this.createSvg()
    }
  },
  mounted () {
    this.createSvg()
  }
}
</script>
